/**
 * Aviso de lectura correcta.
 *
 * En iOS NO hay vibración: `navigator.vibrate` no existe en WebKit y todos los
 * navegadores del iPhone son WebKit. Por eso el sonido es el canal principal y
 * la vibración un extra donde exista, más un destello visual que funciona en
 * todas partes y también para quien lleve el móvil en silencio.
 * Ver DECISIONS.md D-21.
 */

let audioContext: AudioContext | null = null;

function getAudioContext(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  try {
    audioContext ??= new AudioContext();
    return audioContext;
  } catch {
    return null;
  }
}

/** Debe llamarse desde un gesto del usuario: iOS no deja crear audio sin él. */
export function primeAudio(): void {
  const ctx = getAudioContext();
  if (ctx?.state === 'suspended') void ctx.resume();
}

function beep(): void {
  const ctx = getAudioContext();
  if (!ctx || ctx.state !== 'running') return;

  const oscillator = ctx.createOscillator();
  const gain = ctx.createGain();
  oscillator.type = 'sine';
  oscillator.frequency.value = 880;

  // Rampa corta: un pitido seco no molesta en un supermercado lleno.
  const now = ctx.currentTime;
  gain.gain.setValueAtTime(0.0001, now);
  gain.gain.exponentialRampToValueAtTime(0.25, now + 0.01);
  gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.12);

  oscillator.connect(gain).connect(ctx.destination);
  oscillator.start(now);
  oscillator.stop(now + 0.14);
}

export function signalSuccess(): void {
  beep();
  try {
    navigator.vibrate?.(60);
  } catch {
    // Vibrar es un adorno; que falle no puede romper el escaneo.
  }
}

/** true cuando el dispositivo puede vibrar, para no prometer lo que no hay. */
export function canVibrate(): boolean {
  return typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function';
}
